import { render } from "./CEMP.vue?vue&type=template&id=96ecca56"
import script from "./CEMP.vue?vue&type=script&lang=js"
export * from "./CEMP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__